import { Avatar as FluentAvatar } from "@fluentui/web-components";
/**
 * Avatar
 * @summary An Avatar Custom HTML Element based on FluentAvatar, including style and layout specific attributes.
 *
 * @example
 * ```html
 * <fabric-avatar
 *   shape="circular"
 *   appearance="ring"
 *   size="48"
 *   color="colorful"
 *   color-id="team-1"
 * >
 *   JD
 *   <span slot="badge">5</span>
 * </fabric-avatar>
 * ```
 *
 * @attr {AvatarShape | undefined} shape - The avatar can have a circular or square shape.
 * @attr {AvatarAppearance | undefined} appearance - The appearance when `active="active"`.
 * @attr {AvatarSize | undefined} size - Size of the avatar in pixels.
 * @attr {AvatarColor | undefined} color - The color when displaying either an icon or initials.
 * @attr {string} color-id - Specify a string to be used instead of the name, to determine which color to use when color="colorful".
 * @attr {string} name - The name of the avatar.
 * @attr {string} initials - The initials of the avatar.
 *
 * @prop {AvatarShape | undefined} shape - The avatar can have a circular or square shape.
 * @prop {AvatarAppearance | undefined} appearance - The appearance when `active="active"`.
 * @prop {AvatarSize | undefined} size - Size of the avatar in pixels.
 * @prop {AvatarColor | undefined} color - The color when displaying either an icon or initials.
 * @prop {string} colorId - Specify a string to be used instead of the name, to determine which color to use when color="colorful".
 * @prop {string} name - The name of the avatar.
 * @prop {string} initials - The initials of the avatar.
 *
 * @slot - The default slot for the avatar's initials or icon.
 * @slot badge - Slot for adding a badge to the avatar.
 *
 * @extends FluentAvatar
 * @tagname fabric-avatar
 * @public
 */
export class Avatar extends FluentAvatar {
}
//# sourceMappingURL=avatar.js.map